import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-auth-code-input',
  templateUrl: './auth-code-input.component.html',
})
export class AuthCodeInputComponent {
  @Output() codeChange = new EventEmitter<string>();
  @Output() enter = new EventEmitter<void>();

  @ViewChildren('box') boxes!: QueryList<ElementRef<HTMLInputElement>>;

  digits = ['', '', '', '', '', ''];

  @Input()
  set code(value: string) {
    const next = (value || '').replace(/[^0-9]/g, '').slice(0, 6);
    if (next === this.digits.join('')) {
      return;
    }
    this.digits = Array.from({ length: 6 }, (_, i) => next[i] ?? '');
  }

  onInput(index: number, event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value.replace(/[^0-9]/g, '');

    if (value.length > 1) {
      this.fillFrom(value);
      return;
    }

    this.digits[index] = value;
    target.value = value;
    if (value) {
      this.focus(index + 1);
    }
    this.emit();
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const text = event.clipboardData?.getData('text') ?? '';
    this.fillFrom(text);
  }

  onKeydown(index: number, event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (this.digits[index]) {
        this.digits[index] = '';
      } else if (index > 0) {
        this.digits[index - 1] = '';
        this.focus(index - 1);
      }
      this.emit();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.focus(index - 1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.focus(index + 1);
      return;
    }

    if (event.key === 'Enter') {
      this.enter.emit();
    }
  }

  onFocus(event: Event) {
    (event.target as HTMLInputElement).select();
  }

  private fillFrom(raw: string) {
    const value = raw.replace(/[^0-9]/g, '').slice(0, 6);
    this.digits = Array.from({ length: 6 }, (_, i) => value[i] ?? '');
    this.focus(Math.min(value.length, 5));
    this.emit();
  }

  private focus(index: number) {
    const boxes = this.boxes?.toArray();
    if (!boxes?.length) {
      return;
    }
    const clamped = Math.max(0, Math.min(index, boxes.length - 1));
    boxes[clamped].nativeElement.focus();
  }

  private emit() {
    this.codeChange.emit(this.digits.join(''));
  }
}
